import DocumentsRfiSecurity from './DocumentsRfiSecurity.component';

export default DocumentsRfiSecurity;